export default __webpack_public_path__ + "static/media/ADP.91f68899.svg";